module.exports = __webpack_public_path__ + "img/us.12df1fb4.jpg";